// src/components/pages/Settings.jsx
import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Switch, Divider } from '@mui/material';

const Settings = () => {
  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Typography variant="h4" gutterBottom>Settings</Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>Preferences</Typography>
        <Divider sx={{ mb: 2 }} />
        
        <List>
          <ListItem>
            <ListItemText primary="Enable Notifications" secondary="Receive notifications about system updates" />
            <Switch defaultChecked />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Dark Mode" secondary="Use dark theme across the application" />
            <Switch />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Email Alerts" secondary="Receive important updates via email" />
            <Switch defaultChecked />
          </ListItem>
        </List>
      </Paper>
      
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Account Settings</Typography>
        <Divider sx={{ mb: 2 }} />
        
        <List>
          <ListItem>
            <ListItemText primary="Two-Factor Authentication" secondary="Add an extra layer of security" />
            <Switch />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Session Timeout" secondary="Automatically log out after 30 minutes of inactivity" />
            <Switch defaultChecked />
          </ListItem>
        </List>
      </Paper>
    </Box>
  );
};

export default Settings;